import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchAudios,
  createAudio,
  updateAudio,
  deleteAudio,
} from '../../api/audiosApi' // Adjust the import path as necessary

export const fetchAudiosThunk = createAsyncThunk(
  'audio/fetchAudios',
  async (_, thunkAPI) => {
    try {
      const response = await fetchAudios()
      if (response.success && Array.isArray(response.audioPodcasts)) {
        return response.audioPodcasts // Ensure we're returning an array
      } else {
        // Handle the case where the response does not include an array of audioPodcasts as expected
        return thunkAPI.rejectWithValue(
          response.message || 'Invalid audioPodcasts data'
        )
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'An error occurred')
    }
  }
)

export const createAudioThunk = createAsyncThunk(
  'audio/createAudio',
  async (audioData: FormData, thunkAPI) => {
    console.log('Dispatched create audui', audioData)
    try {
      const response = await createAudio(audioData)
      if (response.success) {
        return response.audioPodcast // Ensure this matches the structure of your CreateAudioResponse
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      // Adjust the error typing based on your environment
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const updateAudioThunk = createAsyncThunk(
  'audio/updateAudio',
  async ({ id, audioData }: { id: string; audioData: FormData }, thunkAPI) => {
    try {
      const response = await updateAudio(id, audioData)
      console.log('Dispatched update audio', response)
      if (response.success) {
        return response.audioPodcast // Ensure this matches the structure of your UpdateAudioResponse
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      // Adjust the error typing based on your environment
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const deleteAudioThunk = createAsyncThunk(
  'audio/deleteAudio',
  async (id: string, thunkAPI) => {
    try {
      const response = await deleteAudio(id)
      if (response.success) {
        return id // Returning the ID to identify which audio was deleted
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      // Adjust the error typing based on your environment
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)
